import { detectedEnv } from './env_config'

export async function reportError (err) {
  // Do not try to report errors in tests

  if (detectedEnv == null) return

  if (err.hasBeenReported) return
  err.hasBeenReported = true
  // errors that are assigned a 4xx error code are user errors
  // that don't need to be reported to the server
  // Ex: invalid form input
  if ((err.statusCode != null) && (err.statusCode < 500)) return

  const data = {
    error: {
      // not simply passing the err object as its properties wouldn't be sent
      message: err.message,
      stack: err.stack,
      context: err.context,
      statusCode: err.statusCode,
    },
  }

  try {
    // (1)
    await fetch('/api/reports/error-report', {
      method: 'post',
      headers: { 'content-type': 'application/json' },
      body: stringifyData(data),
    })
  } catch (err) {
    console.error('could not report error', err)
    // Do not rethrow error to prevent an error reporting loop
  }
}

// (1): Using fetch directly instead of preq to be able to report errors
// happening before preq is initialized

const stringifyData = function (data) {
  try {
    return JSON.stringify(data)
  } catch (err) {
    // Typically a 'cyclic object value' error
    data.context = `context couldn't be attached: ${err.message}`
    return JSON.stringify(data)
  }
}
